import type { HideUnsubmittedFormRule } from "../../../../../../shared/schema";
import { useNewFormsExperienceForms } from "../../../useNewFormsExperienceForms";
import { DEFAULT_HIDE_UNSUBMITTED_AFTER } from "./constants";

export type HideUnsubmittedRuleMode = "hide" | "never";

export const useHideUnsubmittedFormRuleRow = (
  rule: HideUnsubmittedFormRule,
  formIdsInOtherRules: string[],
  onChange: (rule: HideUnsubmittedFormRule) => void
) => {
  const { searchQuery, setSearchQuery, formsById, isLoading } = useNewFormsExperienceForms({
    enabled: true,
    selectedFormIds: rule.formIds,
  });

  // A form belongs to at most one rule, so forms another rule already covers are not offered
  const options = [...formsById.values()].flatMap((form) =>
    rule.formIds.includes(form.id) || !formIdsInOtherRules.includes(form.id)
      ? [{ form, label: form.displayTitle ? `${form.title} (${form.displayTitle})` : form.title }]
      : []
  );

  const handleModeChange = (mode: string) => {
    if (mode === "never") onChange({ ...rule, hideAfter: null });
    if (mode === "hide") onChange({ ...rule, hideAfter: DEFAULT_HIDE_UNSUBMITTED_AFTER });
  };

  return {
    mode: rule.hideAfter ? "hide" : "never",
    options,
    searchQuery,
    setSearchQuery,
    isLoading,
    handleFormIdsChange: (formIds: string[]) => onChange({ ...rule, formIds }),
    handleModeChange,
  };
};
